import { map } from 'rxjs/operators';
import { FleetPainTrends } from '../models/fleet-pain-trends.model';
import { Injectable } from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Burly} from 'kb-burly';

@Injectable({
  providedIn: 'root'
})
export class TorchFleetPainTrendsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getFleetPainTrends(type: string,
                            type1?: string,
                            type2?: string): Observable<FleetPainTrends[]> {

    let finalURL;
    let typeURL;

    if (type === 'total') {
      typeURL = 'total/list/total';
    } else if (type === 'acn') {
      typeURL = 'acn/list/acn/' + type1;
    } else if (type === 'ata') {
      typeURL = 'ata/list/ata/' + type1;
    } else if (type === 'ata-acn') {
      typeURL = 'ata/acn/list/ata/' + type1 + '/acn/' + type2;
    } else if (type === 'ata-fleet') {
      typeURL = 'ata/fleet/list/ata/' + type1 + '/fleet/' + type2;
    } else if (type === 'atachapter') {
      typeURL = 'atachapter/list/atachapter/' + type1;
    } else if (type === 'atachapter-acn') {
      typeURL = 'atachapter/acn/list/atachapter/' + type1 + '/acn/' + type2;
    } else if (type === 'atachapter-fleet') {
      typeURL = 'atachapter/fleet/list/atachapter/' + type1 + '/fleet/' + type2;
    } else if (type === 'fleet') {
      typeURL = 'fleet/list/fleet/' + type1;
    }

    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/pain-index/trends')
    .addSegment('/' + typeURL);

    finalURL = endpointURL.get;

    return this.httpClient.get<FleetPainTrends[]>(finalURL);
  }

  public getDistinctAtas(type: string): Observable<string[]> {

    let finalURL;
    let typeURL;

    if (type === 'ata') {
      typeURL = 'ata/atas';
    } else if (type === 'ata-acn') {
      typeURL = 'ata/acn/atas';
    } else if (type === 'ata-fleet') {
      typeURL = 'ata/fleet/atas';
    }

    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/pain-index/trends')
    .addSegment('/' + typeURL);

    finalURL = endpointURL.get;

    return this.httpClient.get<[{ ATA: string }]>(finalURL).pipe(
      map(response => response.map(v => v.ATA))
    );
  }

  public getDistinctAtaChapters(type: string): Observable<string[]> {

    let finalURL;
    let typeURL;

    if (type === 'atachapter') {
      typeURL = 'atachapter/atachapters';
    } else if (type === 'atachapter-acn') {
      typeURL = 'atachapter/acn/atachapters';
    } else if (type === 'atachapter-fleet') {
      typeURL = 'atachapter/fleet/atachapters';
    }

    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/pain-index/trends')
    .addSegment('/' + typeURL);

    finalURL = endpointURL.get;

    return this.httpClient.get<[{ ATA_CHAPTER: string }]>(finalURL).pipe(
      map(response => response.map(v => v.ATA_CHAPTER))
    );
  }

  public getDistinctFleets(type: string): Observable<string[]> {

    let finalURL;
    let typeURL;

    if (type === 'fleet') {
      typeURL = 'fleet/fleets';
    } else if (type === 'ata-fleet') {
      typeURL = 'ata/fleet/fleets';
    } else if (type === 'atachapter-fleet') {
      typeURL = 'atachapter/fleet/fleets';
    }

    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/pain-index/trends')
    .addSegment('/' + typeURL);

    finalURL = endpointURL.get;

    return this.httpClient.get<[{ FLEET_CD: string }]>(finalURL).pipe(
      map(response => response.map(v => v.FLEET_CD))
    );
  }

  public getDistinctAcns(type: string): Observable<string[]> {

    let finalURL;
    let typeURL;

    if (type === 'acn') {
      typeURL = 'acn/acns';
    } else if (type === 'ata-acn') {
      typeURL = 'ata/acn/acns';
    } else if (type === 'atachapter-acn') {
      typeURL = 'atachapter/acn/acns';
    }

    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/pain-index/trends')
    .addSegment('/' + typeURL);

    finalURL = endpointURL.get;

    return this.httpClient.get<[{ ACN: string }]>(finalURL).pipe(
      map(response => response.map(v => v.ACN))
    );
  }
}
